import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { SUPPORT_EMAIL } from "../../lib/common/constants";

export const SupportBtn = ({ isLandingPage = false }: { isLandingPage?: boolean }) => {
    const refSupportModal = useRef<HTMLDivElement>(null);
    const windowGlobal = window as any;

    const handleFirstModalShow = () => {
        const showModal1 = () => {
            if (!refSupportModal.current) {
                setTimeout(() => {
                    showModal1();
                }, 100);
                return;
            }
            windowGlobal.wwg_refSupportModal = new window.bootstrap.Modal(refSupportModal.current);

            windowGlobal.wwg_refSupportModal.show();
        };

        showModal1();
    };
    const handleFirstModalClose = () => {
        if (!refSupportModal.current) {
            setTimeout(() => {
                handleFirstModalClose();
            }, 100);
            return;
        }
        if (windowGlobal.wwg_refSupportModal) {
            //TODO: change to window.bootstrap.Modal.getInstance(refSupportModal.current)?.hide(); when we update to bootstrap 5.2
            windowGlobal.wwg_refSupportModal.hide();
        }
    };

    useEffect(() => {
        return () => {
            if (windowGlobal.wwg_refSupportModal) {
                windowGlobal.wwg_refSupportModal.hide();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const modalContent = (
        <div className="modal fade" tabIndex={-1} ref={refSupportModal}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header bg-primary">
                        <h1 className="modal-title fs-5 text-white">
                            {" "}
                            <i className="fa-regular fa-circle-question me-3 fs-lg"></i>
                            Contact Support
                        </h1>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            // data-bs-dismiss="modal"
                            onClick={handleFirstModalClose}
                        ></button>
                    </div>
                    <div className="modal-body p-5">
                        <p className="fw-bold">
                            Need help? <br />
                            Send us an email, and we’ll get back to you as soon as possible!
                        </p>
                        <a className="btn-link text-primary fw-bold" href={"mailto:" + SUPPORT_EMAIL}>
                            {SUPPORT_EMAIL}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
            <button type="button" className="btn nav-row rounded-3 border-0 top-menu__icon-action" onClick={handleFirstModalShow}>
                <i className={`fa-regular fa-circle-question fs-4 top-menu__support-icon ${isLandingPage ? "text-muted" : "text-white"}`}></i>
            </button>
            {createPortal(modalContent, document.body)}
        </>
    );
};
